import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Skeleton } from 'primereact/skeleton';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FilterMatchMode } from 'primereact/api';
import Conexao from '../../../providers/Conexao';
import Layout from '../../Layout';
import fontConfig from '../../../Componentes/FontConfig';
import { useLocation } from 'react-router-dom';
import { OverlayPanel } from 'primereact/overlaypanel';
import { SplitButton } from 'primereact/splitbutton';
import { Toast } from 'primereact/toast';
import { FileUpload } from 'primereact/fileupload';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { Tooltip } from 'primereact/tooltip';
import { Divider } from 'primereact/divider';
import { Tag } from 'primereact/tag';
import { InputSwitch } from "primereact/inputswitch";
import { SpeedDial } from 'primereact/speeddial';
import { ProgressSpinner } from 'primereact/progressspinner';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import BotaoEditar from '../../../Componentes/BotaoEditar';
import BotaoExcluir from '../../../Componentes/BotaoExcluir';
import { getDataRepository } from '../../../providers/Repository';
import DisplayStatusEquipamento from './Componentes/DisplayStatusEquipamento';
import { RadioButton } from 'primereact/radiobutton';
import SidebarColetas from './Componentes/SidebarColetas';
import TonerLevel from '../../../Componentes/TonerLevel';
import { Badge } from 'primereact/badge';
import { Slider } from "primereact/slider";
import SidebarDetalheColetas from './Componentes/SidebarDetalheColetas';
import { Chip } from 'primereact/chip';
import { Menu } from 'primereact/menu';
import SidebarFiltrosPrevisao from './Componentes/SidebarFiltrosPrevisao';
import { MultiSelect } from 'primereact/multiselect';
import ModalGraficoConsumo from './Componentes/ModalGraficoConsumo';
import SidebarDetalhesTrocaPecas from './Componentes/SidebarDetalhesTrocaPecas';
import { Calendar } from 'primereact/calendar';


export default function VisaoTrocaParts(props) {
    const toast = React.useRef(null); // Ref para o Toast
    const [ingredient, setIngredient] = useState('parque');
    const [selectedCores, setSelectedCores] = useState(null);
    const [visible, setVisible] = useState({
        visible : false, 
        alerta : []
    });
    const [coleta, setColeta] = useState([])
    const [loading, setLoading] = useState(false);

    const [coletas, setColetas]= useState([]);
    
    const [selectedColetas, setSelectedColetas]= useState([]);
    
    const [selectAll, setSelectAll] = useState(false);

    const [fieldsFound, setFieldsFound] = useState([]);

    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [parametroData, setParametroData] = useState(['',''])
    
    const location = useLocation();

    const { dataEmpresa } = location.state || {};

    const op = useRef(null); // Referência para o OverlayPanel
    const [openFilter, setOpenFilter] = useState(false)
    const requisicaoInicialData = useRef(false); // Referência para o botão de filtro

    const [totalRegistros, setTotalRegistros] = useState(0)
    const [diasPesquisa, setDiasPesquisa] = useState([0,999])

    const [faixaTonerPreto, setFaixaTonerPreto] = useState([0,100])
    const [verCorPreta, setVerCorPreta] = useState(true)
    const [verCorCiano, setVerCorCiano] = useState(true)
    const [verCorMagenta, setVerCorMagenta] = useState(true)
    const [verCorAmarelo, setVerCorAmarelo] = useState(true)
    const [dias, setDias] = useState([1, 365])
    const [openPrevisao, setOpenPrevisao] = useState([])
    const [dataInicial, setDataInicial] = useState('')
    const [dataFinal, setDataFinal] = useState('')

    
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        idempresa: { value: '', matchMode: FilterMatchMode.EQUALS },
        numeroserie: { value: '', matchMode: FilterMatchMode.CONTAINS },
        modelo: { value: '', matchMode: FilterMatchMode.CONTAINS },
        marca: { value: '', matchMode: FilterMatchMode.CONTAINS }, 
        prtalertdescription : { value: '', matchMode: FilterMatchMode.CONTAINS },       
        datatroca :   {
            operator: 'and',
            constraints: [
                { value: null, matchMode: FilterMatchMode.BETWEEN },
                { value: null, matchMode: FilterMatchMode.BETWEEN }
            ]
        },
    });
    



 useEffect(() => {
        if(!requisicaoInicialData.current){
            getData();
            requisicaoInicialData.current = true
        }else{

        }
        
    }, []);

    const getData = () => {
       
        clearFilters()

        setLoading(true)

        Conexao.post('coletasController/getTrocasParts', {
            idempresa : dataEmpresa.idempresa, 
            idcliente : dataEmpresa.idcliente ? dataEmpresa.idcliente : -1, 
            fullData : 't'
        })
        .then(response => {

           if(response.status === 200 && response.data.status === 'OK'){
                const temp = response.data.payload
                for(let i = 0; i < temp.length; i++){
                    temp[i].dataFilter = new Date(temp[i].dataalerta)
                }
                console.log(temp)
                setColetas(response.data.payload)

           }else{

            setColetas([])

           }
           
            setLoading(false)

        }).catch(error => {
            
            setColetas([])

            setLoading(false);

            showMessageToast('error', "Não foi possível recuperar dados")
        });
    };

  
    const showMessageToast = (severity, msg) => {
        switch(severity){
            case "error":
                toast.current.show({
                    severity: "error",
                    summary: "Erro",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

            case "success":
                toast.current.show({
                    severity: "success",
                    summary: "Sucess",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

            case "warn":
                toast.current.show({
                    severity: "warn",
                    summary: "Warning",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

        }
        
      };


    const handleFilterChange = (e, field) => {

        const value = e.target.value;
        
        setFilters(prevFilters => ({
            ...prevFilters,
            [field]: { value, matchMode: FilterMatchMode.CONTAINS },
            
        }));
    };

    const [overlayVisible, setOverlayVisible] = useState(false);

    const handleFilterConfirm = () => {
        // Aqui você pode aplicar os filtros ao DataTable ou fazer outras ações necessárias
        setOverlayVisible(false); // Fecha o overlay após aplicar os filtros
    };

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        setGlobalFilterValue(value);
    
        // Atualizar o filtro global
        const _filters = { ...filters };
        _filters['global'].value = value;
        
       
        setFilters(_filters);
    
        // Identificar os campos onde o filtro foi encontrado
      
    };
    
 

    const menuRight = useRef(null);


    const renderHeader = () => {

        return (

            <React.Fragment>
                
            <div className="flex flex-wrap align-items-center" style={{paddingBottom : '10px', paddingTop : '10px', paddingLeft : '0px'}}>
                <div className="col-12 md:col-10">
                    <div className="flex flex-wrap align-items-center gap-5">
                        <div className='col-12 md:col-2 pl-2 pr-2 '>
                        <IconField iconPosition="left" className='w-full'>
                            <InputIcon className="pi pi-search" />
                            <InputText 
                                value={globalFilterValue} 
                                onChange={onGlobalFilterChange} 
                                disabled = {loading}
                                placeholder="Pesquisa global" 
                                tooltip="Pesquise por qualquer campo da tabela" tooltipOptions={{ position: 'bottom' }}
                            />
                            
                        </IconField>
                        </div>
                        
                        
                        <div className='col-12 md:col-1 pl-2 pr-2 gap-2'>
                            <div className='flex justify-content-around align-items-center'>
                                <div style={{paddingRight : '5px'}}>
                                    <Button
                                            type="button"
                                            icon="pi pi-calendar"
                                            className="p-button-secondary p-button-sm" 
                                            tooltip="Abrir opções de pesquisa por data de abertura do alerta" tooltipOptions={{ position: 'bottom' }}
                                            onClick={(e) => menuRight.current.toggle(e)}
                                        />
                                        <OverlayPanel ref={menuRight} style={{marginTop: '-94px'}}>
                                            <div className="flex flex-column gap-3 p-2 " >
                                                <span>Data Inicial:</span>
                                                <Calendar 
                                                    showIcon 
                                                    tooltip="Data inicial do filtro de pesquisa" tooltipOptions={{ position: 'bottom' }}
                                                    dateFormat="yy-mm-dd" 
                                                    value={dataInicial}
                                                    onChange={(e) => setDataInicial(e.value)}/>
                                                <span>Data Final:</span>
                                                <Calendar 
                                                    showIcon  
                                                    dateFormat="yy-mm-dd" 
                                                    tooltip="Data final do filtro de pesquisa" tooltipOptions={{ position: 'bottom' }}
                                                    value={dataFinal}
                                                    onChange={(e) => setDataFinal(e.value)}/>
                                                <Button label="Aplicar" icon="pi pi-check" 
                                                    tooltip="Aplicar a data como filtro de dados" 
                                                    tooltipOptions={{ position: 'bottom' }} onClick={(e) => {
                                                
                                                      setFilters(prev => ({
                                                        ...prev,
                                                        dataalerta: {
                                                            value: [new Date(dataInicial) ,new Date(dataFinal)],
                                                            matchMode: FilterMatchMode.BETWEEN
                                                          }
                                                    }));
                                              
                                                      menuRight.current.toggle(e);
                                                    
                                                }}/>
                                            </div>
                                        </OverlayPanel>
                                </div>
                                <Button 
                                    icon="pi pi-filter-slash" 
                                    className="p-button-secondary p-button-sm" 
                                    onClick={clearFilters} 
                                    disabled = {loading}
                                    tooltip="Limpar todos os filtros" tooltipOptions={{ position: 'bottom' }}
                                />
                        
                                <Button 
                                    icon="pi pi-sync" 
                                    className= "p-button-primary p-button-sm ml-2" 
                                    onClick={getData} 
                                    disabled = {loading}
                                    tooltip="Buscar dados..." tooltipOptions={{ position: 'bottom' }}
                                /> 
                               
                            </div>
                          
                         </div>           
                                
                    </div>
                    
                </div>
                
            </div>

            </React.Fragment>

        );
    };
    

    const renderFooter = () => {
        if (fieldsFound.length === 0) {
            return  <div className="w-10 text-left" style={{ fontSize: '10px', color: '#444' }}>
            Total de registros: {totalRegistros} 
        </div>
        }
        
        return <>
        <div className="w-10 text-left" style={{ fontSize: '10px', color: '#444' }}>
            Total de registros: {totalRegistros} 
        </div>
        <div className="w-10 text-left" style={{ fontSize: '10px', color: '#444' }}>
            Filtro encontrado em: {fieldsFound.join(', ')}
        </div>
    </>
    };

    const clearFilters = () => {
        setGlobalFilterValue('');
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            idempresa: { value: '', matchMode: FilterMatchMode.EQUALS },
            numeroserie: { value: '', matchMode: FilterMatchMode.CONTAINS },
            modelo: { value: '', matchMode: FilterMatchMode.CONTAINS },
            marca: { value: '', matchMode: FilterMatchMode.CONTAINS },    
            prtalertdescription : { value: '', matchMode: FilterMatchMode.CONTAINS },    
            datatroca :   {
                operator: 'and',
                constraints: [
                    { value: null, matchMode: FilterMatchMode.BETWEEN },
                    { value: null, matchMode: FilterMatchMode.BETWEEN }
                ]
            },
        });        
        setFieldsFound([]); // Resetando os campos encontrados
        setFaixaTonerPreto([0,100])
        setVerCorCiano(true)
        setVerCorMagenta(true)
        setVerCorAmarelo(true)
        setVerCorPreta(true)
        setDataInicial('')
        setDataFinal('')
        setDias([1,365])
    };



 
    
    return (
        <Layout loading={loading}>
            <div className="p-2">
              

                <div className="border-round-lg surface-card shadow-0 p-2">
                    {/* Botão para abrir o OverlayPanel */}
                    
                
                        <DataTable
                            header={renderHeader()}  
                           
                            value={coletas}
                            paginator 
                            totalRecords={coletas.length}             
                            rows={25} // Número de itens por página
                            rowsPerPageOptions={[10, 15, 20, 25,50]} // Opções de páginas
                            responsiveLayout="scroll"
                            paginatorTemplate="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Registro {first} até {last} de {totalRecords} registro(s)" 
                            tableStyle={{ minWidth: '35rem' }}
                            filters={filters} // Aplicando os filtros
                            filterDisplay="menu" // Exibe os filtros como menu pop-up
  
                        >
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '10%', paddingTop : '2px', paddingBottom : '2px' }} 
                                headerStyle={{ fontSize: fontConfig.small }} 
                                field="prtalertdescription" 
                                header="Descrição" 
                                body={(row)=>loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : <span>{row.prtalertdescription}</span>
                                }
                                sortable                            
                                filterPlaceholder="Filtrar pelo nº cartucho" />
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '4%', paddingTop : '2px', paddingBottom : '2px' }} 
                                headerStyle={{ fontSize: fontConfig.small }} 
                                field="datalog" 
                                header="Data Troca" 
                                body={(row)=>loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : <>
                                <span style={{fontSize : '0.8rem'}}>{row.dataalerta.substr(0,10)+' '+row.horaalerta?.substr(0,8)}</span><br/>
                                
                                </>
                                }
                                sortable 
                                filterPlaceholder="Filtrar pelo serial" />
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '3%', paddingTop : '2px', paddingBottom : '2px' }} 
                                headerStyle={{ fontSize: fontConfig.small }} 
                                field="numeroserie" 
                                header="Serial" 
                                body={(row)=>loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : 
                                <Tag severity="contrast" style={{cursor:'pointer'}} className='w-full' value={row.numeroserie} onClick={()=>{
                                  
                                  
                                }}></Tag>
                                }
                                sortable 
                                filter 
                                filterElement={(options) => (
                                                                    <InputText
                                                                        value={options.value}                                        
                                                                        onChange={(e) => options.filterCallback(e.target.value)}
                                                                        onClick={(e) => e.stopPropagation()} // impede que o sort seja disparado
                                                                        placeholder=""
                                                                        />
                                                                )} 
                                filterPlaceholder="Filtrar pelo serial" />
                             <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '6%', paddingTop : '2px', paddingBottom : '2px' }} 
                                headerStyle={{ fontSize: fontConfig.small }} 
                                field="marca" 
                                header="Marca" 
                                body={(row)=>loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : 
                                <div>
                                    <span className='text-sm'>{row.marca}</span><br/>                            
                                </div>
                                }
                                sortable 
                                filter
                                filterElement={(options) => (
                                                                    <InputText
                                                                        value={options.value}                                        
                                                                        onChange={(e) => options.filterCallback(e.target.value)}
                                                                        onClick={(e) => e.stopPropagation()} // impede que o sort seja disparado
                                                                        placeholder=""
                                                                        />
                                                                )}  
                                filterPlaceholder="Filtrar pela Marca" />
                                <Column 
                                    bodyStyle={{ fontSize: fontConfig.small , width : '10%', paddingTop : '2px', paddingBottom : '2px' }} 
                                    headerStyle={{ fontSize: fontConfig.small }} 
                                    field="modelo" 
                                    header="Equipamento" 
                                    body={(row)=>loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : 
                                    <div>
                            
                                        <span className='text-sm'>{row.modelo}</span><br/>
                                    </div>
                                    }
                                    sortable 
                                    filter 
                                    filterElement={(options) => (
                                                                        <InputText
                                                                            value={options.value}                                        
                                                                            onChange={(e) => options.filterCallback(e.target.value)}
                                                                            onClick={(e) => e.stopPropagation()} // impede que o sort seja disparado
                                                                            placeholder=""
                                                                            />
                                                                    )} 
                                    filterPlaceholder="Filtrar pelo modelo" />

                               
                           
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '3%', paddingTop : '2px', paddingBottom : '2px' }} 
                                headerStyle={{ fontSize: fontConfig.small }} 
                                field="prtalertcode" 
                                header="RCF-1759 Grupo" 
                                body={(row)=>loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : <span>{row.prtalertcode}</span>
                                }
                                sortable                         
                                filterPlaceholder="Filtrar pelo nº cartucho" />                           
                               
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '3%', paddingTop : '2px', paddingBottom : '2px' }} 
                                headerStyle={{ fontSize: fontConfig.small , textAlign:'center'}} 
                                header="VER" 
                                body={(row)=>loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : 
                                <Button 
                                    icon="pi pi-clipboard" 
                                    className="p-button-secondary p-button-sm" 
                                    onClick={(op)=>{
                                        setVisible({
                                            visible : true, 
                                            alerta : row
                                        })
                                    }}
                                    tooltip='Ver mais informações sobre a troca' tooltipOptions={{ position: 'left' }}
                                />
                                } 
                                /> 
                                
                        </DataTable>
                    
                </div>                
            </div>

            <OverlayPanel ref={op} style={{ width: '300px' }}>
                    <div className="p-3">
                        <h4>Filtros</h4>                                          
                        <div className="p-field">
                            <label htmlFor="razaosocial">Marca</label>
                            <InputText
                                id="marca"
                                value={filters.marca.value}
                                onChange={(e) => handleFilterChange(e, 'marca')}
                            />
                        </div>

                        <div className="p-field">
                            <label htmlFor="razaosocial">Modelo</label>
                            <InputText
                                id="modelo"
                                value={filters.modelo.value}
                                onChange={(e) => handleFilterChange(e, 'modelo')}
                            />
                        </div>
                       

                        <Button label="Aplicar Filtro" icon="pi pi-check" onClick={handleFilterConfirm} />
                    </div>
                </OverlayPanel>
             <Toast ref={toast} />
            <SidebarDetalhesTrocaPecas
                openModal ={visible}
                closeModal = {setVisible} />
        </Layout>
    );
}
